
import { addDays, addMonths, addWeeks, addYears, format } from 'date-fns';

export const getNextDate = (currentDate: Date, frequency: string | null | undefined) => {
  switch (frequency) {
    case 'daily':
      return addDays(currentDate, 1);
    case 'weekly':
      return addWeeks(currentDate, 1);
    case 'biweekly':
      return addWeeks(currentDate, 2);
    case 'monthly':
      return addMonths(currentDate, 1);
    default:
      return addMonths(currentDate, 1);
  }
};

export const calculateTotalRecurrences = (
  startDate: Date,
  endDate: Date,
  frequency: string | null | undefined
) => {
  if (endDate < startDate) {
    return 0;
  }

  let count = 0;
  let currentDate = new Date(startDate);

  // Create a safety limit to prevent infinite loops (e.g. 50 years of daily events)
  const SAFETY_LIMIT = 20000;

  while (currentDate <= endDate && count < SAFETY_LIMIT) {
    count++;
    currentDate = getNextDate(currentDate, frequency);
  }

  return count;
};

export const generateRecurrenceDates = (
  startDate: Date,
  frequency: string | null | undefined,
  count: number
): Date[] => {
  const dates: Date[] = [];
  let currentDate = new Date(startDate);

  for (let i = 0; i < count; i++) {
    dates.push(new Date(currentDate));
    currentDate = getNextDate(currentDate, frequency);
  }

  return dates;
};

export const generateRecurrenceDatesUntil = (
  startDate: Date,
  endDate: Date,
  frequency: string | null | undefined
): Date[] => {
  const dates: Date[] = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate = getNextDate(currentDate, frequency);
  }

  return dates;
};

export const previewRecurrence = (
  startDate: Date,
  frequency: string | null | undefined,
  repeatCount?: number,
  endDate?: Date
): { dates: Date[]; count: number } => {
  let dates: Date[] = [];

  if (repeatCount) {
    dates = generateRecurrenceDates(startDate, frequency, repeatCount);
  } else if (endDate) {
    dates = generateRecurrenceDatesUntil(startDate, endDate, frequency);
  }

  return {
    dates,
    count: dates.length
  };
};

export const toDateString = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

export const fromDateString = (dateString: string): Date => {
  // Handle YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return new Date(dateString + 'T00:00:00:00');
  }
  // Handle ISO strings
  return new Date(dateString);
};
